import { TooltipContentSizes } from './types';
import { small, medium, large } from './styles';

export const mapSizes: TooltipContentSizes = {
  small,
  medium,
  large,
};
